export default "__VITE_ASSET__7b7dfe6c__"